import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/')({
  validateSearch: zodValidator(withDefaults(schema.ALL_ACCOUNTS, defaultFilter)),
});
